import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { getFileFromUser } from '@weblite/file'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { RemoveIcon } from '$common/icons/remove'
import { EditPhotoIcon } from '$common/icons/edit-photo'
import { uploadImage } from '$func/upload-image'
import { t } from '$i18n'
import { showEditProfileDialog } from '$comp/modals/edit-profile-dialog'

interface Props {
  isOpen: boolean
  showDelete: boolean
  // NOTE: for deleting image, fileId should be null
  onSubmit: (fileId: string | null) => unknown
}

export function ProfilePictureMenu({ isOpen, showDelete, onSubmit }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.profileImage.newImage')}
        onClick={async () => {
          await closeCurrentModal()
          getFileFromUser(
            'image/*',
            file => {
              showEditProfileDialog({
                file: Array.isArray(file) ? file[0] : file,
                onCancel: closeCurrentModal,
                setFile: async (editedFile: File) => {
                  await uploadImage(editedFile, ({ fileId }) => {
                    onSubmit(fileId)
                  })
                  closeCurrentModal()
                },
                onResetCb: closeCurrentModal,
              })
            },
            false,
          )
        }}
      >
        <EditPhotoIcon />
      </PopupMenuItem>

      {showDelete ? (
        <PopupMenuItem
          text={t('menu.profileImage.deleteCurrent')}
          onClick={async () => {
            await closeCurrentModal()
            onSubmit(null)
          }}
        >
          <RemoveIcon />
        </PopupMenuItem>
      ) : undefined}
    </PopupMenuList>
  )
}
